// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import ReactAnimateHeight from "react-animate-height";

var _map = {"visible":"auto","hidden":"0%"};

var _revMap = {"auto":"visible","0%":"hidden"};

function visibilityToJs(param) {
  return _map[param];
}

function visibilityFromJs(param) {
  return _revMap[param];
}

var AnimateJs = {};

function AnimateHeight(props) {
  return React.createElement(ReactAnimateHeight, {
              height: visibilityToJs(props.visibility),
              duration: props.duration,
              onHeightAnimationEnd: props.onHeightAnimationEnd,
              children: props.children
            });
}

var make = AnimateHeight;

export {
  visibilityToJs ,
  visibilityFromJs ,
  AnimateJs ,
  make ,
}
/* react Not a pure module */
